export interface TagOption {
  tag: string;
  contacts: number;
}

interface Props {
  id: string;
  options: TagOption[];
  selected: string[];
  match: 'any' | 'all';
  onChange: (selected: string[], match: 'any' | 'all') => void;
}

/**
 * Contact-tag filter.
 *
 * A picker that adds, plus removable chips for what is on — a `<select multiple>`
 * hides the current selection behind a scroll and is miserable past a handful
 * of options, and agencies accumulate a lot of tags.
 */
export function TagFilter({ id, options, selected, match, onChange }: Props) {
  const available = options.filter((option) => !selected.includes(option.tag));

  return (
    <div className="field" style={{ minWidth: 200 }}>
      <label htmlFor={id}>Contact tags</label>
      <div className="row" style={{ alignItems: 'center' }}>
        <select
          id={id}
          value=""
          onChange={(event) => {
            if (event.target.value) onChange([...selected, event.target.value], match);
          }}
        >
          <option value="">{selected.length ? 'Add another tag…' : 'Any tag'}</option>
          {available.map((option) => (
            <option value={option.tag} key={option.tag}>
              {option.tag} ({option.contacts})
            </option>
          ))}
        </select>

        {selected.length > 1 ? (
          <select
            aria-label="Tag match mode"
            value={match}
            onChange={(event) => onChange(selected, event.target.value as 'any' | 'all')}
          >
            <option value="any">any of</option>
            <option value="all">all of</option>
          </select>
        ) : null}
      </div>

      {selected.length > 0 ? (
        <div className="chips" style={{ marginTop: 6 }}>
          {selected.map((tag) => (
            <button
              type="button"
              className="chip"
              key={tag}
              aria-pressed="true"
              title={`Remove ${tag}`}
              onClick={() => onChange(selected.filter((item) => item !== tag), match)}
            >
              {tag} ✕
            </button>
          ))}
        </div>
      ) : null}
    </div>
  );
}
